/**
 * 文章咨询的浏览展示
 */

import React from 'react';
import { Modal, Button } from 'antd';

class NoticeDialog extends React.Component {

    render() {
        return (
            <Modal
                width={800}
                title={this.props.title}
                visible={this.props.visible}
                onOk={this.props.onCancel}
                onCancel={this.props.onCancel}
                okText="确认"
                cancelText="取消"
                footer={[
                    <Button type="primary" key="primary" onClick={this.props.onCancel}>确定</Button>,
                ]}
            >
                <div className="modalContent" dangerouslySetInnerHTML={{ __html: this.props.content }} />
            </Modal>
        )
    }
}
export default NoticeDialog;